module.exports = __webpack_public_path__ + "static/media/OrleansMasterClass2013.67ccaf31.JPG";